import Typography from '@mui/material/Typography';
import { useConfig } from '@/hooks/useConfig';
import Box from '@mui/material/Box';

const Environment = () => {
  const { config } = useConfig();

  return config.environment !== 'PROD' ? (
    <Box
      sx={{
        position: 'absolute',
        top: '.5rem',
        right: '.5rem'
      }}
    >
      <Typography variant='body2' color='textDisabled' fontWeight='bold'>
        {config.environment}
      </Typography>
    </Box>
  ) : null;
};

export default Environment;
